//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'QuantitySelector',
  props: {
    maxQuantity: {
      type: Number,
      default: 1
    },
    initialQuantity: {
      type: Number,
      default: 1
    }
  },

  data() {
    return {
      quantity: 1
    };
  },

  watch: {
    quantity() {
      this.$emit('update-quantity', this.quantity);
    }

  },

  created() {
    this.quantity = this.initialQuantity;
  },

  methods: {
    increment() {
      this.quantity = this.quantity < this.maxQuantity ? this.quantity + 1 : this.quantity;
    },

    decrement() {
      if (this.quantity === 1) {
        this.$emit('input');
      } else {
        this.quantity -= 1;
      }
    }

  }
};